import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30dcdc33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "promotion__banner" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "inner",
  style: { display: 'flex', gap: '8px', padding: '32px 20px 15px 20px' }
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "inner" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "inner" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "courses__container" }
const _hoisted_13 = {
  class: "course__info",
  id: "course__info"
}
const _hoisted_14 = { class: "inner" }
const _hoisted_15 = { class: "course__step" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-text" }, "초보 과정 커리큘럼", -1 /* HOISTED */))
const _hoisted_17 = { class: "course__special" }
const _hoisted_18 = { class: "course__slide__wrapper" }
const _hoisted_19 = { class: "course__slide" }
const _hoisted_20 = { class: "course__step" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "swiper-text",
  style: {"margin-top":"23px"}
}, "중급이상 과정 커리큘럼", -1 /* HOISTED */))
const _hoisted_22 = { class: "course__special" }
const _hoisted_23 = { class: "course__slide__wrapper" }
const _hoisted_24 = { class: "course__slide" }
const _hoisted_25 = { class: "inner" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "inner" }
const _hoisted_28 = {
  class: "inner",
  style: {"margin-top":"23px"}
}
const _hoisted_29 = { class: "promotion-notice" }
const _hoisted_30 = { class: "notice__item" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "notice__title" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 7L8 11L4 7",
  stroke: "#121214",
  "stroke-opacity": "0.6",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1 /* HOISTED */))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 0,
  class: "notice__list"
}
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "wrapper" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-impact" }, [
  /*#__PURE__*/_createTextVNode(" 초보 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-blur" }, "수강권 보기")
], -1 /* HOISTED */))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-impact" }, [
  /*#__PURE__*/_createTextVNode(" 중급 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-blur" }, "수강권 보기")
], -1 /* HOISTED */))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "sheet__wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppNav = _resolveComponent("AppNav")!
  const _component_bottom_sheet = _resolveComponent("bottom-sheet")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_PageCRMSurveyVue = _resolveComponent("PageCRMSurveyVue")!
  const _component_Pr90DaysOptions = _resolveComponent("Pr90DaysOptions")!
  const _directive_img_lazy_loading = _resolveDirective("img-lazy-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" app nav "),
    ($options.appView)
      ? (_openBlock(), _createBlock(_component_AppNav, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode("작심 패키지")
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: "promotion",
      style: _normalizeStyle({ 'padding-top': $options.appPadding, 'padding-bottom': $options.appBottom })
    }, [
      _createCommentVNode(" <div\n      v-if=\"isPurchaseClicked\"\n      class=\"common-modal common-modal--dimmed\"\n      id=\"modalCertificateClose\"\n      style=\"display: block\"\n    >\n      <div class=\"common-modal__modal modal--purchase\" v-click-outside=\"closePurchaseModal\">\n        <div class=\"common-modal__content\">\n          <div class=\"common-modal__description\" v-html=\"purchaseErrorMessage\"></div>\n          <div class=\"common-modal__description--small\">\n            {{ purchaseErrorSubMessage }}\n          </div>\n        </div>\n\n        <div class=\"common-modal__buttonWrap\" v-if=\"puchaseErrorType === 'level'\">\n          <button type=\"button\" class=\"common-modal__button\" @click=\"closePurchaseModal\">취소</button>\n          <button type=\"button\" class=\"common-modal__button\" @click=\"goPurchasePage\">확인</button>\n        </div>\n        <div class=\"common-modal__buttonWrap\" v-if=\"puchaseErrorType === 'hasTicket'\">\n          <button type=\"button\" class=\"common-modal__button\" @click=\"closePurchaseModal\">확인</button>\n        </div>\n      </div>\n    </div> "),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: $data.imgUrls.img_mind_top
          }, null, 8 /* PROPS */, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: $data.imgUrls.img_mind_point01
          }, null, 8 /* PROPS */, _hoisted_5),
          _createElementVNode("img", {
            src: $data.imgUrls.img_mind_point02
          }, null, 8 /* PROPS */, _hoisted_6),
          _createElementVNode("img", {
            src: $data.imgUrls.img_mind_point03
          }, null, 8 /* PROPS */, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            src: $data.imgUrls.img_common_sec01
          }, null, 8 /* PROPS */, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("img", {
            src: $data.imgUrls.img_mind_sec01
          }, null, 8 /* PROPS */, _hoisted_11)
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_bottom_sheet, {
          isShow: $data.isBottomSheetVisible,
          onClose: $options.closeBottomSheet
        }, null, 8 /* PROPS */, ["isShow", "onClose"])
      ]),
      _createElementVNode("section", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_swiper, {
                      "slides-per-view": 9,
                      "space-between": 18,
                      centeredSlides: true,
                      slideToClickedSlide: true,
                      style: {"min-width":"2502px !important"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course1,
                              title: $data.courseInfos.course1.title,
                              paragraph: $data.courseInfos.course1.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course2,
                              title: $data.courseInfos.course2.title,
                              paragraph: $data.courseInfos.course2.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course3,
                              title: $data.courseInfos.course3.title,
                              paragraph: $data.courseInfos.course3.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course4,
                              title: $data.courseInfos.course4.title,
                              paragraph: $data.courseInfos.course4.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course5,
                              title: $data.courseInfos.course5.title,
                              paragraph: $data.courseInfos.course5.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course6,
                              title: $data.courseInfos.course6.title,
                              paragraph: $data.courseInfos.course6.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course7,
                              title: $data.courseInfos.course7.title,
                              paragraph: $data.courseInfos.course7.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course8,
                              title: $data.courseInfos.course8.title,
                              paragraph: $data.courseInfos.course8.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course9,
                              title: $data.courseInfos.course9.title,
                              paragraph: $data.courseInfos.course9.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_swiper, {
                      "slides-per-view": 9,
                      "space-between": 16,
                      centeredSlides: true,
                      slideToClickedSlide: true,
                      style: {"min-width":"2502px !important"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course1_middle,
                              title: $data.courseInfos_middle.course1.title,
                              paragraph: $data.courseInfos_middle.course1.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course2_middle,
                              title: $data.courseInfos_middle.course2.title,
                              paragraph: $data.courseInfos_middle.course2.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course3_middle,
                              title: $data.courseInfos_middle.course3.title,
                              paragraph: $data.courseInfos_middle.course3.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course4_middle,
                              title: $data.courseInfos_middle.course4.title,
                              paragraph: $data.courseInfos_middle.course4.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course5_middle,
                              title: $data.courseInfos_middle.course5.title,
                              paragraph: $data.courseInfos_middle.course5.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course6_middle,
                              title: $data.courseInfos_middle.course6.title,
                              paragraph: $data.courseInfos_middle.course6.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course7_middle,
                              title: $data.courseInfos_middle.course7.title,
                              paragraph: $data.courseInfos_middle.course7.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course8_middle,
                              title: $data.courseInfos_middle.course8.title,
                              paragraph: $data.courseInfos_middle.course8.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_swiper_slide, { class: "slide__card" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_Accordion, {
                              imgUrl: $data.imgUrls.course9_middle,
                              title: $data.courseInfos_middle.course9.title,
                              paragraph: $data.courseInfos_middle.course9.paragraph
                            }, null, 8 /* PROPS */, ["imgUrl", "title", "paragraph"]), [
                              [_directive_img_lazy_loading]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createCommentVNode(" <앺ㅇ "),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("img", {
          src: $data.imgUrls.img_mind_sec02
        }, null, 8 /* PROPS */, _hoisted_26)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("button", {
          class: "detail-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.toggleBottomSheet && $options.toggleBottomSheet(...args)))
        }, "수료 조건 자세히 보기")
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_PageCRMSurveyVue)
      ]),
      _createElementVNode("section", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.promotionData.planGuide, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "notice",
              key: index
            }, [
              _createElementVNode("div", {
                class: "box",
                onClick: ($event: any) => ($options.toggleContent(index))
              }, [
                _createElementVNode("div", _hoisted_32, _toDisplayString(item.title), 1 /* TEXT */),
                (_openBlock(), _createElementBlock("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "16",
                  height: "16",
                  viewBox: "0 0 16 16",
                  fill: "none",
                  class: _normalizeClass({ 'rotate-arrow': $data.showContentIndex === index })
                }, _hoisted_34, 2 /* CLASS */))
              ], 8 /* PROPS */, _hoisted_31),
              ($data.showContentIndex === index)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sortNoticeText[index], (text, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: i,
                        class: "list__item"
                      }, [
                        _createElementVNode("p", { innerHTML: text }, null, 8 /* PROPS */, _hoisted_36)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createCommentVNode("맨아래 구매유도 버튼(계속 보이는거)"),
      _createElementVNode("section", {
        class: _normalizeClass(["challenge-cta", { 'ani-bottom-up': $data.bottomCtaUp }]),
        id: "challengeCta"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["challenge-cta__wrap", { sheetOn: $data.isMobileBottomSheetOpen }])
        }, [
          _createElementVNode("div", _hoisted_37, [
            ($data.isMobileBottomSheetOpen)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.purchasePlan())),
                  type: "button",
                  class: "bottom_tab"
                }, " 혜택 확인하기 "))
              : _createCommentVNode("v-if", true),
            (!$data.isMobileBottomSheetOpen)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.goToApply && $options.goToApply(...args))),
                  type: "button",
                  class: "fixed__button"
                }, _hoisted_39))
              : _createCommentVNode("v-if", true),
            (!$data.isMobileBottomSheetOpen)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.goToApplyMiddle && $options.goToApplyMiddle(...args))),
                  type: "button",
                  class: "fixed__button"
                }, _hoisted_41))
              : _createCommentVNode("v-if", true)
          ])
        ], 2 /* CLASS */),
        _createElementVNode("article", {
          class: _normalizeClass(["sheet", { 'is-show': $data.isMobileBottomSheetOpen }]),
          id: "bottomUpSheet"
        }, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", {
              class: "btn",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.closeBottomSheetTab(), _ctx.trackingUserAction('chobo_package_footer_close')))
            }),
            _createVNode(_component_Pr90DaysOptions, {
              onUpdate: $options.updateOptionIdx,
              promotionData: $data.promotionData,
              choicedOptionIdx: $data.choicedOptionIdx,
              choicedOptionData: $data.choicedOptionData,
              isRecommendIdx: $data.isRecommendIdx
            }, null, 8 /* PROPS */, ["onUpdate", "promotionData", "choicedOptionIdx", "choicedOptionData", "isRecommendIdx"])
          ]),
          _createElementVNode("div", {
            class: "dim",
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.closeBottomSheetTab(), _ctx.trackingUserAction('chobo_package_footer_close')))
          })
        ], 2 /* CLASS */)
      ], 2 /* CLASS */)
    ], 4 /* STYLE */)
  ], 64 /* STABLE_FRAGMENT */))
}